/**
 * Generated by orval from the Collective Payroll API contract. Do not edit manually.
 */

/**
 * * `fixed` - fixed
 * * `hourly` - hourly
 * * `unknown` - unknown
 */
export type ContractorPaymentWageTypeEnum =
    (typeof ContractorPaymentWageTypeEnum)[keyof typeof ContractorPaymentWageTypeEnum];

export const ContractorPaymentWageTypeEnum = {
    fixed: 'fixed',
    hourly: 'hourly',
    unknown: 'unknown',
} as const;
